import IBrowserPageViewport from './types/IBrowserPageViewport.js';

export default <IBrowserPageViewport>{
	width: 1024,
	height: 768,
	devicePixelRatio: 1
};
